// extracted by mini-css-extract-plugin
export default {"wrapper":"LoginWidget_wrapper__yn6FS","logo":"LoginWidget_logo__Qmp7J","content":"LoginWidget_content__ZxVlh","title":"LoginWidget_title__UjfFC"};